import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-rundown',
  imports: [CommonModule, ReactiveFormsModule],
  standalone: true,
  template: `
    <div
      class="flex flex-col justify-between gap-y-4 sm:gap-y-6 w-full"
      [formGroup]="rundown"
    >
      <div class="flex flex-col w-full ">
        <h2 class="text-base font-semibold leading-7 text-gray-900">Rundown</h2>
      </div>

      <div class="flex flex-col gap-x-6  w-full">
        <!-- Location Input -->
        <div class=" flex flex-col w-full">
          <label
            for="rundown"
            class=" hidden mb-2 text-sm font-medium text-gray-700"
            >Bitte Rundown beschreiben</label
          >
          <textarea
            id="rundown"
            type="text"
            rows="5"
            formControlName="text"
            class="text-sm sm:text-xs w-full rounded-md border border-gray-300 py-2 px-3 text-gray-700 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            placeholder="Rundown eingeben..."
          ></textarea>
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class RundownComponent {
  @Input({ required: true }) rundown!: FormGroup;
}
